import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}`;

// Statistics Panel
export function getStatisticsPanel() {
  return axios.get(`${API_URL}/dashboards`);
}

export function getInventoryStatus() {
  return axios.get(`${API_URL}/dashboards/inventories`);
}

export function getActiveStores(query) {
  return axios.post(`${API_URL}/reports/dailystorereport`, { ...query });
}
